import React from 'react';
import BaseEditPage from "../../Base/BaseEditPage";
import BaseMapSub from "../../Base/BaseMapSub";
import ZmuPreRouteMap from "../../Maps/ZMU/ZmuPreRouteMap";

const keyName = `ZmuPreRouteMapSub`;

export default class ZmuPreRouteMapSub extends BaseMapSub {

    constructor(props) {
        super(props);
        const context = this;
        context.state = {showAll: true};
    }

    getMap(context, params = {}) {
        let parent = context.props.parent.props.parent;
        while (!(parent instanceof BaseEditPage)) {
            parent = parent.props.parent;
        }
        const height = context.getHeight() || 500;
        return <ZmuPreRouteMap
            ref={(mapRef => {
                context.olMap = mapRef;
                parent.olMap = mapRef;
            })}
            height={height}
            readonly={(!context.props.parent.isEditRight())}
            rights={params.rights || context.props.rights}
            key={'preRouteMap'}
            layerNames={context.props.layerNames || [{
                layerName: 'pre_routes',
                hidden: false,
                type: 'own'
            }, {
                layerName: 'routeslin',
                hidden: false,
                type: 'own'
            }]}
            record={context.props.record}
            parent={parent}
            appViewPort={context.props.appViewPort}
        />;
    }
}

